




































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationRules } from "_P/validate";
import { Person } from "@/services/index.defs";
@Component
export default class PersonNameBD extends Vue {
    @Prop(Boolean) wide: boolean;
    @Prop() person: Person;
    Rules = ValidationRules;

    @Watch("person.isWithoutLastName")
    isWithoutLastNameChanged(val) {
        if (val) this.person.patronymic = "";
    }
}
